import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import SupportPage from './SupportPage';
import { saveQueryType, saveMessages, saveAttachment, doSubmit, onFilesChange, onFilesError, ticketGen, orderno } from 'src/actions/supportAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
// import { handleCloseAlert } from 'src/actions/errorAction';
// import { push } from 'react-router-redux';

export const mapStateToProps = (state: AppState) => {
  return {
    // errorMessage: state.errorState.errorMessage,
    // errorBar: state.errorState.errorBar,
    // successMessage: state.errorState.successMessage,
    // successBar: state.errorState.successBar,
    // errorfilemsg: state.errorState.errorfilemsg,
    // errorFileUploadedOpen: state.errorState.errorFileUploadedOpen,

    // successFileUploadOpen: state.errorState.successFileUploadOpen,
    // successfilemsg: state.errorState.successfilemsg,
    queryType: state.support.querytype,
    message: state.support.message,
    ticketGen: state.support.docid,
    orderNo: state.support.orderNo,
    messageFiles: state.support.messageFilesSupp,
    orderDisabled: state.support.ordernoDisabled,
    supportRequestTypes: state.supportRequest.supportRequestTypes
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onComponentDidMount: () => {
      // dispatch(saveMessages(''));
      // dispatch(saveQueryType('1'));
      // dispatch(ticketGen());
      dispatch(onFilesChange([]));
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
      dispatch(saveMessages(''));
      dispatch(saveQueryType(''));
      dispatch(ticketGen());
    },
    onSubmit: () => {
      // dispatch(fetchCurrentUser);
      dispatch(doSubmit);
    },
    saveQueryType: (querytype: string) => {
      dispatch(saveQueryType(querytype));
    },
    saveMessages: (message: string) => {
      dispatch(saveMessages(message));
    },
    saveAttachment: (attachment: string) => {
      dispatch(saveAttachment(attachment));
    },
    onFilesChange: function (messageFiles: Array<File>) {
      dispatch(onFilesChange(messageFiles));
    },
    onFilesError: function (error: Error, images: Array<File>) {
      dispatch(onFilesError(error, images));
    },
    saveOrderNo: (orderNo: string) => {
      dispatch(orderno(orderNo));
    },
    // handleClose: () => {
    //   dispatch(handleCloseAlert);
    // },
  };
};

const SupportPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportPage);

export default SupportPageContainer;



// WEBPACK FOOTER //
// ./src/components/support/SupportPageContainer.tsx